import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchInterpretersList } from 'slices/interpreterSlice';
import { interpreterSelector } from 'slices/interpreterSlice';
import './SelectInterperter.css';
import { Controller } from 'react-hook-form';
import { Switch } from '@mui/material';

const ListInterperter = ({ setInterpreter, exclude_interpreter = false, autoSelectAll = false, language_id = null, filters = {} }) => {
    const dispatch = useDispatch();
    const { interpreter: interpreters, loader: loaderInterpreter } = useSelector(interpreterSelector);

    const [interpreterList, setInterpreterList] = useState([]);
    const [selectedInterpreters, setSelectedInterpreters] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    // const lastFetchedParams = useRef(null);

    // Fetch all interpreters on component mount and when dependencies change
    useEffect(() => {
        const currentParams = { exclude_interpreter, language_id, filters };
        const paramsKey = JSON.stringify(currentParams);

        const cachedData = sessionStorage.getItem(paramsKey);
        if (cachedData) {
            const cachedList = JSON.parse(cachedData);
            setInterpreterList(cachedList);
            if (autoSelectAll) {
                const allIds = cachedList.map(item => ({
                    value: item?.id,
                    label: item?.first_name,
                    id: item?.id,
                    name: item?.first_name
                }));
                setSelectedInterpreters(allIds);
                setInterpreter({ interpreter_id: allIds });
            } else {
                setSelectedInterpreters(prev => prev?.filter(p => cachedList.some(r => r.id === p.id)) || []);
                setInterpreter({ interpreter_id: selectedInterpreters?.filter(p => cachedList.some(r => r.id === p.id)) || [] });
            }
            return;
        }
     
            const fetchAllInterpreters = async () => {
            try {
                const params = {
                    pageLength: 1000,
                    sortBy: "id",
                    sortDirection: "asc",
                    exclude_interpreter: exclude_interpreter ? 1 : 0,
                    language_id: language_id,
                    service_type: 'interpreter',
                    ...filters
                };
                const result = await dispatch(fetchInterpretersList(1, params, true, true));
                if (result?.data) {
                    setInterpreterList(result.data);
                    sessionStorage.setItem(paramsKey, JSON.stringify(result.data));

                    // Auto-select all if autoSelectAll is true
                    if (autoSelectAll) {
                        const allIds = result.data.map(item => ({
                            value: item?.id,
                            label: item?.first_name,
                            id: item?.id,
                            name: item?.first_name
                        }));
                        setSelectedInterpreters(allIds);
                        setInterpreter({ interpreter_id: allIds });
                    } else {
                        // If exclude changed, clear selection to avoid selecting excluded interpreters
                        setSelectedInterpreters(prev => prev?.filter(p => result.data.some(r => r.id === p.id)) || []);
                        setInterpreter({ interpreter_id: selectedInterpreters?.filter(p => result.data.some(r => r.id === p.id)) || [] });
                    }
                }
            } catch (error) {
                console.error("Error fetching interpreters:", error);
            }
        };

        fetchAllInterpreters();
    }, [dispatch, exclude_interpreter, language_id, JSON.stringify(filters), autoSelectAll]);

    // Handle individual checkbox selection
    const handleInterpreterToggle = (interpreter) => {
        const isSelected = selectedInterpreters.find(item => item.id === interpreter.id);
        
        let updatedList;
        if (isSelected) {
            updatedList = selectedInterpreters.filter(item => item.id !== interpreter.id);
        } else {
            updatedList = [...selectedInterpreters, {
                value: interpreter.id,
                label: interpreter.first_name,
                id: interpreter.id,
                name: interpreter.first_name
            }];
        }
        
        setSelectedInterpreters(updatedList);
        setInterpreter({ interpreter_id: updatedList });
    };

    // Filter interpreters based on search
    const filteredInterpreters = interpreterList.filter(interpreter =>
        interpreter.first_name?.toLowerCase().includes(searchInput.toLowerCase())
    );

    // Select all interpreters
    const handleSelectAll = () => {
        const allIds = filteredInterpreters.map(item => ({
            value: item?.id,
            label: item?.first_name,
            id: item?.id,
            name: item?.first_name
        }));
        setSelectedInterpreters(allIds);
        setInterpreter({ interpreter_id: allIds });
    };

    // Deselect all interpreters
    const handleDeselectAll = () => {
        setSelectedInterpreters([]);
        setInterpreter({ interpreter_id: [] });
    };

    return (
        
<>
            {loaderInterpreter && <p className="loading-text">Loading vendors...</p>}

            <div className="interpreter-list">
                {filteredInterpreters.length > 0 ? (
                    filteredInterpreters.map((interpreter) => (
                        <div key={interpreter.id} className="interpreter-item">
                            <input
                                type="checkbox"
                                id={`interpreter-${interpreter.id}`}
                                checked={selectedInterpreters.some(item => item.id === interpreter.id)}
                                onChange={() => handleInterpreterToggle(interpreter)}
                                className="interpreter-checkbox d-none"
                                disabled
                            />
                            <label htmlFor={`interpreter-${interpreter.id}`} className="interpreter-label">
                                {interpreter.first_name} {interpreter.last_name}
                            </label>
                        </div>
                    ))
                ) : (
                    <p className="no-results">No Vendors found</p>
                )}
            </div>

            <div className="interpreter-count">
                <p>{selectedInterpreters.length} vendor(s) selected</p>
            </div>
            </>
    )
}

export default ListInterperter